import { useQuery } from "@tanstack/react-query";

export const LOGIN_STATUS_QUERY_KEY = "login-status";

export function useLoginStatus() {
  const loginStatus = useQuery({
    queryKey: [LOGIN_STATUS_QUERY_KEY],
    queryFn: fetchLoginStatus,
    staleTime: Infinity,
    refetchOnWindowFocus: "always",
  });
  return loginStatus;
}

export type LoginStatus = LoggedOut | LoginData;

export type LoginData = {
  state: "logged in";
  username: string;
  userId: number;
  is_staff: boolean;
  permissions: string[];
};

export type LoggedOut = {
  state: "logged out";
};

async function fetchLoginStatus(): Promise<LoginStatus> {
  const response = await fetch("/accounts/whoami", {
    redirect: "manual",
  });

  if (!response.ok) {
    throw new Error("Could not fetch login status.");
  }

  const data = await response.json();

  if (!data.userId && !data.username) {
    return { state: "logged out" };
  }

  return { ...data, state: "logged in" };
}
